<main class="report-viewer-container" [attr.aria-label]="Constants.MainAriaLabel">
  <!-- Navigation Header -->
  <header class="report-navigation-header">
    <nav class="nav-content" [attr.aria-label]="Constants.NavAriaLabel">
      <!-- Symetra Logo -->
      <div class="symetra-logo">
        <img src="assets/images/symetra_logo.svg" alt="Symetra Financial" class="logo-image" />
      </div>

      <!-- Download Button with Popup -->
      <div class="download-button-container">
        <dxo-button-v2 [label]="Constants.DownloadButtonLabel" variant="secondary" size="x-small" (handleClick)="toggleDownloadPopup()"
        [attr.aria-expanded]="showDownloadPopup" aria-controls="download-instructions"></dxo-button-v2>

        <!-- Download Instructions Popup -->
        @if (showDownloadPopup) {
          <div id="download-instructions" class="download-popup" [class.visible]="showDownloadPopup"
            role="region" [attr.aria-label]="Constants.DownloadInstructionsLabel">
            <div class="popup-content">
              <div>
                <p class="popup-text">
                  {{ Constants.DownloadInstructionText1 }}
                </p>
                <p class="popup-text">
                  {{ Constants.DownloadInstructionText2 }}
                </p>
              </div>
              <!-- Visual Guide -->
              <figure class="visual-guide" aria-labelledby="guide-caption">
                <div class="guide-image">
                  <img src="assets/images/quicksight-download-guide.png" alt="" class="guide-screenshot" />
                </div>
                <figcaption id="guide-caption" class="sr-only">
                  {{ Constants.VisualGuideCaption }}
                </figcaption>
              </figure>
            </div>
          </div>
        }
      </div>
    </nav>
  </header>

  <!-- Loading State -->
  @if (isLoading) {
    <section class="loader-container" aria-live="polite" [attr.aria-label]="Constants.LoadingReportLabel">
      <dxo-circular-loader [size]="'medium'" [color]="'blue'"
      [attr.aria-label]="Constants.LoadingClaimsDataLabel"></dxo-circular-loader>
      <span class="sr-only">{{ Constants.LoadingReportWaitText }}</span>
    </section>
  }

  <!-- Report Content -->
  @if (!isLoading && embedUrl) {
    <section class="report-content-wrapper" role="region"
      [attr.aria-label]="Constants.ReportDashboardLabel">
      <div class="report-content report-iframe-container">
        <iframe [src]="embedUrl" (load)="onIframeLoad()" [style.opacity]="isIframeLoading ? '0' : '1'"
          title="Interactive Claims Report Dashboard - Use keyboard navigation and screen reader to access report data"
          frameborder="0" allowfullscreen
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-downloads"
        class="report-iframe"></iframe>
      </div>
    </section>
  }

  <!-- Placeholder Content for Testing (when QuickSight is disabled) -->
  @if (!isLoading && !embedUrl) {
    <section class="report-content-wrapper" role="region" [attr.aria-label]="Constants.TestContentLabel">
      <div class="iframe-loading-overlay" aria-live="polite" [attr.aria-label]="Constants.LoadingReportContentLabel">
        <dxo-circular-loader class="quicksight-loader" [size]="'medium'" [color]="'blue'"
        [attr.aria-label]="Constants.LoadingReportContentLabel"></dxo-circular-loader>
        <span class="loading-text">{{ Constants.LoadingReportDataText }}</span>
      </div>
    </section>
  }
</main>